<dialog-header label='{{title}}' [dialogRef]='dialogRef' [object]='this'></dialog-header>
<mat-dialog-content>{{message}}</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngIf="yesTitle.length" mat-stroked-button [mat-dialog-close]="true" cdkFocusInitial>{{yesTitle}}</button>
  <button *ngIf="noTitle.length" mat-stroked-button [mat-dialog-close]="false">{{noTitle}}</button>
</mat-dialog-actions>
